import React from 'react';

import type { ButtonProps } from '@twilio-paste/core/button';
import { Button } from '@twilio-paste/core/button';
import { Tooltip } from '@twilio-paste/core/tooltip';
import { InformationIcon } from '@twilio-paste/icons/esm/InformationIcon';

interface InfoIconProps {
  tooltipText: string;
  iconVariant?: ButtonProps['variant'];
  as?: ButtonProps['as'];
}

export function InfoIcon({
  tooltipText,
  iconVariant = 'secondary_icon',
  as = 'button',
}: InfoIconProps) {
  return (
    <Tooltip text={tooltipText}>
      <Button variant={iconVariant} size="reset" as={as}>
        <InformationIcon decorative />
      </Button>
    </Tooltip>
  );
}
